import { Amount } from "@goodfill/domain-properties";

export const ratingRangeIds = ["bad", "okay", "good", "great"] as const;

export const debtDistributionRatingLabel: Record<RatingRangeId, string> = {
  bad: "<BBB-",
  okay: "BBB",
  good: "A- to A+",
  great: "AA- to AAA",
};

export type RatingRangeId = typeof ratingRangeIds[number];

export interface DebtDistributionPart {
  ratingRangeId: RatingRangeId;
  maturityYears: number;
  faceAmount: Amount;
}

export type DebtDistribution = DebtDistributionPart[];
